import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import store from './store/store.js';
import { addOfferCategory } from './libs/helpers.js';
import { BrowserRouter } from 'react-router-dom';
import { getLanguageEndpoints } from './libs/language';
import { setTextToTraslateTool } from './libs/messages.js';

const App = lazy(() => import(/* webpackPrefetch: true */ './App.js'));

const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(
//   <div className='loadingSite'>
//     <img src={`${process.env.PUBLIC_URL}/img/logo_market.png`} alt='Logo market' />
//   </div>
// )



fetch(`${process.env.PUBLIC_URL}/config.json`)
  .then((response) => response.json())
  .then((res) => {   
    localStorage.setItem('site', res?.WebSection);
    let petitions = [];
    let zero =`${process.env.PUBLIC_URL}/traslations.json`;
    let one =
      getLanguageEndpoints(res.urlAPI, res.urlAPIDev, res.WebSection) +
      '/getCatalogItemsJson'; //webservices
    let two =
      getLanguageEndpoints(res.urlAPI, res.urlAPIDev, res.WebSection) +
      '/getCategories'; //webservices

    petitions.push(one);
    petitions.push(two);
    petitions.push(zero);
    petitions.push(`${process.env.PUBLIC_URL}/offers.json`);

    Promise.all(
      petitions.map(async (url) => {
        let resp = await fetch(url, {
          method: 'get',
        });
        return resp.json();
      })
    )
      .then((resArray) => {
        setTextToTraslateTool(resArray[2]);
        //falta agregar es state inicial de la app
        root.render(
          <Suspense
            fallback={
              <div className='loadingSite'>
                <img src={`${process.env.PUBLIC_URL}/img/logo_market.png`} alt='Logo market' />
              </div>
            }
          >
            <Provider store={store}>
              <BrowserRouter>
                <App
                  config={res}
                  categories={addOfferCategory(resArray[1])} //Webservices
                  offers={resArray[3]}
                  items={resArray[0]}
                />
              </BrowserRouter>
            </Provider>
          </Suspense>
        );
      })
      .catch((err) => {
        console.log(err.message ? '2: ' + err.message : 'Error');
      });
  })
  .catch((err) => {
    console.log(err.message ? err.message : 'Error');
  });
